module.exports = __webpack_public_path__ + "img/JLTP_content_N4.3d068dc7.svg";